const db = "athleteContacts";

export const newContact = (data) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firestore = getFirestore();
    const firebase = getFirebase();
    const batch = firestore.batch();

    const currentTime = firebase.firestore.Timestamp.fromDate(new Date());

    const docRef = firestore.collection(db).doc(data.id);

    const toFirestore = {
      ...data,
      modifiedAt: currentTime,
    };

    batch.set(docRef, toFirestore, { merge: true });

    batch
      .commit()
      .then(() => {})
      .catch(() => {});
  };
};
